import '../vendor';

import '../general/ofi';
import './one-route/sl-gallery';


// WEBPACK FOOTER //
// ./src/js/pages/one-route.js